import { createRoot } from "react-dom/client";
import { TwitterTweetEmbed } from "react-twitter-embed";

const findHeadingByContent = (content: string) => {
  const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  for (let i = 0; i < headings.length; i++) {
    if (content?.includes(headings[i].textContent || "")) {
      return headings[i];
    }
  }

  return null;
};

const scrollElementIntoView = (element: Element | null, offset = 50) => {
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
  }
};

const replaceDivsWithTweets = (html: string) => {
  const doc = document.createElement("div");
  doc.innerHTML = html;

  const divs = doc.querySelectorAll("div[data-lexical-tweet-id]");

  divs.forEach(div => {
    const tweetId = div.getAttribute("data-lexical-tweet-id");

    if (tweetId) {
      const containerDiv = document.createElement("div");
      const root = createRoot(containerDiv);
      root.render((<TwitterTweetEmbed tweetId={tweetId} />) as any);
      div.innerHTML = "";
      div.appendChild(containerDiv);
    }
  });

  const contentElm = document.getElementById("blog-detail");
  if (contentElm) {
    contentElm.innerHTML = "";
    contentElm.appendChild(doc);
  }

  // Remove text-align: justify from h2 elements
  const h2Elements = doc.querySelectorAll("h2");
  h2Elements.forEach(h2 => {
    h2.style.removeProperty("text-align");
  });
};

export { findHeadingByContent, replaceDivsWithTweets, scrollElementIntoView };
